import {LoggedUser} from 'app/_interfaces/logged-user';

export const replaceUrlParams = (url: string, user: LoggedUser): string => {
	const params = {
		clinicId: user.clinicId,
		userId: user.guid,
		authorId: user.guid,
	};

	return Object.keys(params).reduce((acc, i) => {
		return acc.replace(new RegExp(`{${i}}`, 'g'), (params as any)[i]);
	}, url);
};
